import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/login/password',
      name: 'login-password',
      component: () => import('@/views/login/Password.vue'),
    },
    {
      path: '/login/pns',
      name: 'login-pns',
      component: () => import('@/views/login/Pns.vue'),
    },
    {
      path: '/login/sms-up',
      name: 'login-sms-up',
      component: () => import('@/views/login/SmsUp.vue'),
    },
    {
      path: '/login/complete',
      name: 'login-complete',
      component: () => import('@/views/login/Complete.vue'),
    },
    {
      path: '/login/forbidden',
      name: 'login-forbidden',
      component: () => import('@/views/login/Forbidden.vue'),
    },
    {
      path: '/common/success',
      name: 'common-success',
      component: () => import('@/views/common/Success.vue'),
    },
    {
      path: '/common/fail',
      name: 'common-fail',
      component: () => import('@/views/common/Fail.vue'),
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/Index.vue'),
    },
    {
      path: '/bet/jcgyj',
      name: 'bet-jcgyj',
      component: () => import('@/views/bet/Gy.vue'),
    },
    {
      path: '/bet/jczq',
      name: 'bet-jczq',
      component: () => import('@/views/bet/Jczq.vue'),
    },
    {
      path: '/bet/jclq',
      name: 'bet-jclq',
      component: () => import('@/views/bet/Jclq.vue'),
    },
    {
      path: '/bet/bd',
      name: 'bet-bd',
      component: () => import('@/views/bet/Bd.vue'),
    },
    {
      path: '/bet/ssq',
      name: 'bet-ssq',
      component: () => import('@/views/bet/Ssq.vue'),
    },
    {
      path: '/bet/dlt',
      name: 'bet-dlt',
      component: () => import('@/views/bet/Dlt.vue'),
    },
    {
      path: '/bet/qlc',
      name: 'bet-qlc',
      component: () => import('@/views/bet/Qlc.vue'),
    },
    {
      path: '/bet/sd',
      name: 'bet-sd',
      component: () => import('@/views/bet/Sd.vue'),
    },
    {
      path: '/bet/pls',
      name: 'bet-pls',
      component: () => import('@/views/bet/Pls.vue'),
    },
    {
      path: '/bet/plw',
      name: 'bet-plw',
      component: () => import('@/views/bet/Plw.vue'),
    },
    {
      path: '/bet/klb',
      name: 'bet-klb',
      component: () => import('@/views/bet/Klb.vue'),
    },
    {
      path: '/bet/qxc',
      name: 'bet-qxc',
      component: () => import('@/views/bet/Qxc.vue'),
    },
    {
      path: '/bet/sfc14',
      name: 'bet-sfc14',
      component: () => import('@/views/bet/Sfc14.vue'),
    },
    {
      path: '/bet/sfc9',
      name: 'bet-sfc9',
      component: () => import('@/views/bet/Sfc9.vue'),
    },
    {
      path: '/rule/bd',
      name: 'rule-bd',
      component: () => import('@/views/rule/Bd.vue'),
    },
    {
      path: '/rule/jcgyj',
      name: 'rule-jcgyj',
      component: () => import('@/views/rule/Gy.vue'),
    },
    {
      path: '/rule/jclq',
      name: 'rule-jclq',
      component: () => import('@/views/rule/Jclq.vue'),
    },
    {
      path: '/rule/jczq',
      name: 'rule-jczq',
      component: () => import('@/views/rule/Jczq.vue'),
    },
    {
      path: '/rule/dlt',
      name: 'rule-dlt',
      component: () => import('@/views/rule/Dlt.vue'),
    },
    {
      path: '/rule/klb',
      name: 'rule-klb',
      component: () => import('@/views/rule/Klb.vue'),
    },
    {
      path: '/rule/pls',
      name: 'rule-pls',
      component: () => import('@/views/rule/Pls.vue'),
    },
    {
      path: '/rule/plw',
      name: 'rule-plw',
      component: () => import('@/views/rule/Plw.vue'),
    },
    {
      path: '/rule/qlc',
      name: 'rule-qlc',
      component: () => import('@/views/rule/Qlc.vue'),
    },
    {
      path: '/rule/qxc',
      name: 'rule-qxc',
      component: () => import('@/views/rule/Qxc.vue'),
    },
    {
      path: '/rule/sd',
      name: 'rule-sd',
      component: () => import('@/views/rule/Sd.vue'),
    },
    {
      path: '/rule/sfc9',
      name: 'rule-sfc9',
      component: () => import('@/views/rule/Sfc9.vue'),
    },
    {
      path: '/rule/sfc14',
      name: 'rule-sfc14',
      component: () => import('@/views/rule/Sfc14.vue'),
    },
    {
      path: '/rule/ssq',
      name: 'rule-ssq',
      component: () => import('@/views/rule/Ssq.vue'),
    },
    {
      path: '/rule/groupon',
      name: 'rule-groupon',
      component: () => import('@/views/rule/Groupon.vue'),
    },
    {
      path: '/trend',
      name: 'trend',
      component: () => import('@/views/trend/Index.vue'),
    },
    {
      path: '/bet-detail/gy',
      name: 'bet-detail-gy',
      component: () => import('@/views/bet-detail/Gy.vue'),
    },
    {
      path: '/bet-detail/jczq',
      name: 'bet-detail-jczq',
      component: () => import('@/views/bet-detail/Jczq.vue'),
    },
    {
      path: '/bet-detail/jclq',
      name: 'bet-detail-jclq',
      component: () => import('@/views/bet-detail/Jclq.vue'),
    },
    {
      path: '/bet-detail/bd',
      name: 'bet-detail-bd',
      component: () => import('@/views/bet-detail/Bd.vue'),
    },
    {
      path: '/bet-detail/ssq',
      name: 'bet-detail-ssq',
      component: () => import('@/views/bet-detail/Ssq.vue'),
    },
    {
      path: '/bet-detail/dlt',
      name: 'bet-detail-dlt',
      component: () => import('@/views/bet-detail/Dlt.vue'),
    },
    {
      path: '/bet-detail/qlc',
      name: 'bet-detail-qlc',
      component: () => import('@/views/bet-detail/Qlc.vue'),
    },
    {
      path: '/bet-detail/sd',
      name: 'bet-detail-sd',
      component: () => import('@/views/bet-detail/Sd.vue'),
    },
    {
      path: '/bet-detail/pls',
      name: 'bet-detail-pls',
      component: () => import('@/views/bet-detail/Pls.vue'),
    },
    {
      path: '/bet-detail/plw',
      name: 'bet-detail-plw',
      component: () => import('@/views/bet-detail/Plw.vue'),
    },
    {
      path: '/bet-detail/klb',
      name: 'bet-detail-klb',
      component: () => import('@/views/bet-detail/Klb.vue'),
    },
    {
      path: '/bet-detail/qxc',
      name: 'bet-detail-qxc',
      component: () => import('@/views/bet-detail/Qxc.vue'),
    },
    {
      path: '/bet-detail/sfc14',
      name: 'bet-detail-sfc14',
      component: () => import('@/views/bet-detail/Sfc14.vue'),
    },
    {
      path: '/bet-detail/sfc9',
      name: 'bet-detail-sfc9',
      component: () => import('@/views/bet-detail/Sfc9.vue'),
    },
    {
      path: '/bonus-optimize/match',
      name: 'bonus-optimize-match',
      component: () => import('@/views/bonus-optimize/Match.vue'),
    },
    {
      path: '/groupon/hall',
      name: 'groupon-hall',
      component: () => import('@/views/groupon/Hall.vue'),
    },
    {
      path: '/groupon/list',
      name: 'groupon-list',
      component: () => import('@/views/groupon/List.vue'),
    },
    {
      path: '/groupon/setting',
      name: 'groupon-setting',
      component: () => import('@/views/groupon/Setting.vue'),
    },
    {
      path: '/groupon/detail',
      name: 'groupon-detail',
      component: () => import('@/views/groupon/Detail.vue'),
    },
    {
      path: '/groupon/user',
      name: 'groupon-user',
      component: () => import('@/views/groupon/User.vue'),
    },
    {
      path: '/groupon/join-record',
      name: 'groupon-join-record',
      component: () => import('@/views/groupon/JoinRecord.vue'),
    },
    {
      path: '/groupon/success',
      name: 'groupon-success',
      component: () => import('@/views/groupon/Success.vue'),
    },
    {
      path: '/follow/detail',
      name: 'follow-detail',
      component: () => import('@/views/follow/Detail.vue'),
    },
    {
      path: '/follow/hall',
      name: 'follow-hall',
      component: () => import('@/views/follow/Hall.vue'),
    },
    {
      path: '/follow/user',
      name: 'follow-user',
      component: () => import('@/views/follow/User.vue'),
    },
    {
      path: '/follow/search',
      name: 'follow-search',
      component: () => import('@/views/follow/Search.vue'),
    },
    {
      path: '/project-list',
      name: 'project-list',
      component: () => import('@/views/project/Index.vue'),
      meta: {
        parent: 'project',
      },
    },
    {
      path: '/project-detail',
      name: 'project-detail',
      component: () => import('@/views/project/Detail.vue'),
    },
    {
      path: '/account-book',
      name: 'account-book',
      component: () => import('@/views/account-book/Index.vue'),
    },
    {
      path: '/account-book/detail',
      name: 'account-book-detail',
      component: () => import('@/views/account-book/Detail.vue'),
    },
    {
      path: '/account-book/settlement',
      name: 'account-book-settlement',
      component: () => import('@/views/account-book/Settlement.vue'),
    },
    {
      path: '/account-book/recharge',
      name: 'account-book-recharge',
      component: () => import('@/views/account-book/Recharge.vue'),
    },
    {
      path: '/payment/card-list',
      name: 'payment-card-list',
      component: () => import('@/views/payment/CardList.vue'),
    },
    {
      path: '/payment/add-card',
      name: 'payment-add-card',
      component: () => import('@/views/payment/AddCard.vue'),
    },
    {
      path: '/payment/xs-agreement',
      name: 'payment-xs-agreement',
      component: () => import('@/views/payment/XsAgreement.vue'),
    },
    {
      path: '/payment/qrcode',
      name: 'payment-qrcode',
      component: () => import('@/views/payment/QRCode.vue'),
    },
    {
      path: '/payment/credit-pay',
      name: 'payment-credit-pay',
      component: () => import('@/views/payment/CreditPay.vue'),
    },
    {
      path: '/payment/bank-pay',
      name: 'payment-bank-pay',
      component: () => import('@/views/payment/BankPay.vue'),
    },
    {
      path: '/payment/result',
      name: 'payment-result',
      component: () => import('@/views/payment/Result.vue'),
    },
    {
      path: '/score',
      name: 'score',
      component: () => import('@/views/score/Index.vue'),
      meta: {
        parent: 'score',
      },
    },
    {
      path: '/score-jczq',
      name: 'score-jczq',
      component: () => import('@/views/score/Jczq.vue'),
      meta: {
        parent: 'score',
      },
    },
    {
      path: '/score-jclq',
      name: 'score-jclq',
      component: () => import('@/views/score/Jclq.vue'),
      meta: {
        parent: 'score',
      },
    },
    {
      path: '/score-bd',
      name: 'score-bd',
      component: () => import('@/views/score/Bd.vue'),
      meta: {
        parent: 'score',
      },
    },
    {
      path: '/result-jczq',
      name: 'result-jczq',
      component: () => import('@/views/result/Jczq.vue'),
    },
    {
      path: '/result-jclq',
      name: 'result-jclq',
      component: () => import('@/views/result/Jclq.vue'),
    },
    {
      path: '/result-bd',
      name: 'result-bd',
      component: () => import('@/views/result/Bd.vue'),
    },
    {
      path: '/result-sfgg',
      name: 'result-sfgg',
      component: () => import('@/views/result/Sfgg.vue'),
    },
    {
      path: '/personal',
      name: 'personal',
      component: () => import('@/views/personal/Index.vue'),
    },
    {
      path: '/personal/information',
      name: 'personal-information',
      component: () => import('@/views/personal/Information.vue'),
    },
    {
      path: '/personal/transform',
      name: 'personal-transform',
      component: () => import('@/views/personal/Transform.vue'),
    },
    {
      path: '/personal/join',
      name: 'personal-join',
      component: () => import('@/views/personal/Join.vue'),
    },
    {
      path: '/personal/about',
      name: 'personal-about',
      component: () => import('@/views/personal/About.vue'),
    },
    {
      path: '/notice-list',
      name: 'notice-list',
      component: () => import('@/views/home/NoticeList.vue'),
    },
    {
      path: '/iframe',
      name: 'iframe',
      component: () => import('@/views/iframe/Index.vue'),
    },
  ],
})

export default router
